import { render, staticRenderFns } from "./MobileTextPanelMoreTools.vue?vue&type=template&id=3fc55964&scoped=true&"
import script from "./MobileTextPanelMoreTools.vue?vue&type=script&lang=js&"
export * from "./MobileTextPanelMoreTools.vue?vue&type=script&lang=js&"
import style0 from "./MobileTextPanelMoreTools.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MobileTextPanelMoreTools.vue?vue&type=style&index=1&id=3fc55964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../abbreviation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc55964",
  null
  
)

export default component.exports